module.exports = __webpack_public_path__ + "static/media/zeewoldeactueel_old.2fc87beb.png";